import { render, staticRenderFns } from "./UploadLink.vue?vue&type=template&id=6732d128&"
import script from "./UploadLink.vue?vue&type=script&lang=js&"
export * from "./UploadLink.vue?vue&type=script&lang=js&"
import style0 from "./UploadLink.vue?vue&type=style&index=0&id=6732d128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports